"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api3ReaderProxyV1__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "api3ServerV1OevExtension_",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "dapiName_",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "dappId_",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "AddressEmptyCode",
        type: "error",
    },
    {
        inputs: [],
        name: "DapiNameIsNotSet",
        type: "error",
    },
    {
        inputs: [],
        name: "DataFeedIsNotInitialized",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "ERC1967InvalidImplementation",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC1967NonPayable",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedInnerCall",
        type: "error",
    },
    {
        inputs: [],
        name: "FunctionIsNotSupported",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInitialization",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitializing",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "OwnableInvalidOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "OwnableUnauthorizedAccount",
        type: "error",
    },
    {
        inputs: [],
        name: "UUPSUnauthorizedCallContext",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "slot",
                type: "bytes32",
            },
        ],
        name: "UUPSUnsupportedProxiableUUID",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "int256",
                name: "current",
                type: "int256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "roundId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "updatedAt",
                type: "uint256",
            },
        ],
        name: "AnswerUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint64",
                name: "version",
                type: "uint64",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "roundId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "startedBy",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startedAt",
                type: "uint256",
            },
        ],
        name: "NewRound",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "UPGRADE_INTERFACE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "api3ServerV1",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "api3ServerV1OevExtension",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dapiName",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dappId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "description",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "getAnswer",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint80",
                name: "",
                type: "uint80",
            },
        ],
        name: "getRoundData",
        outputs: [
            {
                internalType: "uint80",
                name: "",
                type: "uint80",
            },
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint80",
                name: "",
                type: "uint80",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "getTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "initialOwner",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "latestAnswer",
        outputs: [
            {
                internalType: "int256",
                name: "value",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "latestRound",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "latestRoundData",
        outputs: [
            {
                internalType: "uint80",
                name: "roundId",
                type: "uint80",
            },
            {
                internalType: "int256",
                name: "answer",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "startedAt",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "updatedAt",
                type: "uint256",
            },
            {
                internalType: "uint80",
                name: "answeredInRound",
                type: "uint80",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "latestTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "read",
        outputs: [
            {
                internalType: "int224",
                name: "value",
                type: "int224",
            },
            {
                internalType: "uint32",
                name: "timestamp",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "version",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "0x6101406040523060805234801561001557600080fd5b50604051611503380380611503833981016040819052610034916101bf565b6001600160a01b03831660c0819052604080516316b53a2760e11b81529051632d6a744e916004808201926020929091908290030181865afa15801561007e573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906100a291906101f4565b6001600160a01b031660a05260e082905261010081905260408051602081018490520160408051601f198184030181529190528051602090910120610120526100e96100f1565b505050610216565b7ff0c57e16840df040f15088dc2f81fe391c3923bec73e23a9662efc9c229c6a00805468010000000000000000900460ff16156101415760405163f92ee8a960e01b815260040160405180910390fd5b80546001600160401b03908116146101a05780546001600160401b0319166001600160401b0390811782556040519081527fc7f505b2f371ae2175ee4913f4499e1f2633a7b5936321eed1cdaeb6115181d29060200160405180910390a15b50565b80516001600160a01b03811681146101ba57600080fd5b919050565b6000806000606084860312156101d457600080fd5b6101dd846101a3565b925060208401519150604084015190509250925092565b60006020828403121561020657600080fd5b61020f826101a3565b9392505050565b60805160a05160c05160e051610100516101205161127461028f600039600061055d0152600081816103c00152610704015260006102f801526000818161047d015261074301526000818161018c015281816105920152610672015260008181610a5601528181610a7f0152610c0201526112746000f3fe6080604052600436106101755760003560e01c8063868fa88c116100cb578063b5ab58dc1161007f578063ce7ebd6d11610059578063ce7ebd6d1461046b578063f2fde38b1461049f578063feaf968c146104bf57600080fd5b8063b5ab58dc1461042b578063b633620c1461042b578063c4d66de81461044b57600080fd5b80639a6fc8f5116100b05780639a6fc8f5146103575780639de0eb04146103ae578063ad3cb1cc146103e257600080fd5b8063868fa88c146102e65780638da5cb5b1461031a57600080fd5b806354fd4d501161012d578063715018a611610107578063715018a6146102925780637284e416146102a75780638205bf6a146102d157600080fd5b806354fd4d501461023457806357de26a414610249578063668a0f021461027d57600080fd5b80634f1ef2861161015e5780634f1ef286146101e757806350d25bcd146101fc57806352d1902d1461021f57600080fd5b80632d6a744e1461017a578063313ce567146101cb575b600080fd5b34801561018657600080fd5b506101ae7f000000000000000000000000000000000000000000000000000000000000000081565b6040516001600160a01b0390911681526020015b60405180910390f35b3480156101d757600080fd5b50604051601281526020016101c2565b6101fa6101f536600461103f565b6104d4565b005b34801561020857600080fd5b506102116104f3565b6040519081526020016101c2565b34801561022b57600080fd5b50610211610506565b34801561024057600080fd5b50611331610211565b34801561025557600080fd5b5061025e610535565b60408051601b9390930b835263ffffffff9091166020830152016101c2565b34801561028957600080fd5b50610211610825565b34801561029e57600080fd5b506101fa610840565b3480156102b357600080fd5b506040805160208101909152600081525b6040516101c2919061112d565b3480156102dd57600080fd5b50610211610854565b3480156102f257600080fd5b506102117f000000000000000000000000000000000000000000000000000000000000000081565b34801561032657600080fd5b507f9016d09d72d40fdae2fd8ceac6b6234c7706214fd39c1cd1e609a0528c199300546001600160a01b03166101ae565b34801561036357600080fd5b50610377610372366004611160565b61086a565b6040805169ffffffffffffffffffff968716815260208101959095528401929092526060830152909116608082015260a0016101c2565b3480156103ba57600080fd5b506102117f000000000000000000000000000000000000000000000000000000000000000081565b3480156103ee57600080fd5b506102c46040518060400160405280600581526020017f352e302e3000000000000000000000000000000000000000000000000000000081525081565b34801561043757600080fd5b5061021161044636600461118c565b610825565b34801561045757600080fd5b506101fa6104663660046111a5565b61088b565b34801561047757600080fd5b506101ae7f000000000000000000000000000000000000000000000000000000000000000081565b3480156104ab57600080fd5b506101fa6104ba3660046111a5565b6109c8565b3480156104cb57600080fd5b50610377610a24565b6104dc610a4b565b6104e582610b02565b6104ef8282610b0a565b5050565b60006104fd610535565b50601b0b919050565b6000610510610bf7565b507f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc90565b6040517f472c22f10000000000000000000000000000000000000000000000000000000081527f00000000000000000000000000000000000000000000000000000000000000006004820152600090819081906001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000169063472c22f190602401602060405180830381865afa1580156105d9573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906105fd91906111c0565b905080610636576040517f8086c76400000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b6040517f67a7cfb70000000000000000000000000000000000000000000000000000000081526004810182905260009081906001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016906367a7cfb7906024016040805180830381865afa1580156106b8573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906106dc91906111d9565b6040517f91526c360000000000000000000000000000000000000000000000000000000081527f0000000000000000000000000000000000000000000000000000000000000000600482015260248101869052919350915060009081906001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016906391526c36906044016040805180830381865afa158015610789573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906107ad91906111d9565b915091508263ffffffff168163ffffffff1611156107d157909550935084846107dc565b838380975081985050505b8563ffffffff1660000361081c576040517f2bb59f0900000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b50505050509091565b6000604051631fc30cb960e01b815260040160405180910390fd5b610848610c40565b6108526000610cb4565b565b600061085e610535565b63ffffffff1692915050565b6000806000806000604051631fc30cb960e01b815260040160405180910390fd5b7ff0c57e16840df040f15088dc2f81fe391c3923bec73e23a9662efc9c229c6a00805468010000000000000000810460ff16159067ffffffffffffffff166000811580156108d65750825b905060008267ffffffffffffffff1660011480156108f35750303b155b905081158015610901575080155b15610938576040517ff92ee8a900000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b845467ffffffffffffffff19166001178555831561096c57845468ff00000000000000001916680100000000000000001785555b61097586610d32565b83156109c057845468ff000000000000000019168555604051600181527fc7f505b2f371ae2175ee4913f4499e1f2633a7b5936321eed1cdaeb6115181d29060200160405180910390a15b505050505050565b6109d0610c40565b6001600160a01b038116610a18576040517f1e4fbdf7000000000000000000000000000000000000000000000000000000008152600060048201526024015b60405180910390fd5b610a2181610cb4565b50565b600080808080610a32610535565b9596601b9190910b9563ffffffff169450849350909150565b306001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000161480610ae457507f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316610ad87f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc546001600160a01b031690565b6001600160a01b031614155b156108525760405163703e46dd60e11b815260040160405180910390fd5b610a21610c40565b816001600160a01b03166352d1902d6040518163ffffffff1660e01b8152600401602060405180830381865afa925050508015610b64575060408051601f3d908101601f19168201909252610b61918101906111c0565b60015b610b8c57604051634c9c8ce360e01b81526001600160a01b0383166004820152602401610a0f565b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc8114610be8576040517faa1d49a400000000000000000000000000000000000000000000000000000000815260048101829052602401610a0f565b610bf28383610d43565b505050565b306001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016146108525760405163703e46dd60e11b815260040160405180910390fd5b33610c727f9016d09d72d40fdae2fd8ceac6b6234c7706214fd39c1cd1e609a0528c199300546001600160a01b031690565b6001600160a01b031614610852576040517f118cdaa7000000000000000000000000000000000000000000000000000000008152336004820152602401610a0f565b7f9016d09d72d40fdae2fd8ceac6b6234c7706214fd39c1cd1e609a0528c199300805473ffffffffffffffffffffffffffffffffffffffff1981166001600160a01b03848116918217845560405192169182907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a3505050565b610d3a610d99565b610a2181610e00565b610d4c82610e08565b6040516001600160a01b038316907fbc7cd75a20ee27fd9adebab32041f755214dbc6bffa90cc0225b39da2e5c2d3b90600090a2805115610d9157610bf28282610e8c565b6104ef610f02565b7ff0c57e16840df040f15088dc2f81fe391c3923bec73e23a9662efc9c229c6a005468010000000000000000900460ff16610852576040517fd7e6bcf800000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b6109d0610d99565b806001600160a01b03163b600003610e3e57604051634c9c8ce360e01b81526001600160a01b0382166004820152602401610a0f565b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc805473ffffffffffffffffffffffffffffffffffffffff19166001600160a01b0392909216919091179055565b6060600080846001600160a01b031684604051610ea99190611222565b600060405180830381855af49150503d8060008114610ee4576040519150601f19603f3d011682016040523d82523d6000602084013e610ee9565b606091505b5091509150610ef9858383610f3a565b95945050505050565b3415610852576040517fb398979f00000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b606082610f4f57610f4a82610fb2565b610fab565b8151158015610f6657506001600160a01b0384163b155b15610fa8576040517f9996b3150000000000000000000000000000000000000000000000000000000081526001600160a01b0385166004820152602401610a0f565b50805b9392505050565b805115610fc25780518082602001fd5b6040517f1425ea4200000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b80356001600160a01b038116811461100b57600080fd5b919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b6000806040838503121561105257600080fd5b61105b83610ff4565b9150602083013567ffffffffffffffff81111561107757600080fd5b8301601f8101851361108857600080fd5b803567ffffffffffffffff8111156110a2576110a2611010565b604051601f8201601f19908116603f0116810167ffffffffffffffff811182821017156110d1576110d1611010565b6040528181528282016020018710156110e957600080fd5b816020840160208301376000602083830101528093505050509250929050565b60005b8381101561112457818101518382015260200161110c565b50506000910152565b602081526000825180602084015261114c816040850160208701611109565b601f01601f19169190910160400192915050565b60006020828403121561117257600080fd5b813569ffffffffffffffffffff81168114610fab57600080fd5b60006020828403121561119e57600080fd5b5035919050565b6000602082840312156111b757600080fd5b610fab82610ff4565b6000602082840312156111d257600080fd5b5051919050565b600080604083850312156111ec57600080fd5b825180601b0b81146111fd57600080fd5b602084015190925063ffffffff8116811461121757600080fd5b809150509250929050565b60008251611234818460208701611109565b919091019291505056fea26469706673582212200ce1fb76af7a7f07e054a40f569323f46509052cccbd884ed6811664ec0b0ec164736f6c634300081b0033";
const isSuperArgs = (xs) => xs.length > 1;
class Api3ReaderProxyV1__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(api3ServerV1OevExtension_, dapiName_, dappId_, overrides) {
        return super.getDeployTransaction(api3ServerV1OevExtension_, dapiName_, dappId_, overrides || {});
    }
    deploy(api3ServerV1OevExtension_, dapiName_, dappId_, overrides) {
        return super.deploy(api3ServerV1OevExtension_, dapiName_, dappId_, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.Api3ReaderProxyV1__factory = Api3ReaderProxyV1__factory;
//# sourceMappingURL=Api3ReaderProxyV1__factory.js.map